import { render, staticRenderFns } from "./SearchProductCard.vue?vue&type=template&id=0296f8cc&scoped=true&"
import script from "./SearchProductCard.vue?vue&type=script&lang=js&"
export * from "./SearchProductCard.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductCard.vue?vue&type=style&index=0&id=0296f8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296f8cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,HepLogo: require('/vercel/path0/components/general/HepLogo.vue').default,ProductAuthors: require('/vercel/path0/components/product/ProductAuthors.vue').default,ProductPrice: require('/vercel/path0/components/product/ProductPrice.vue').default,ArrowLeft: require('/vercel/path0/components/icons/ArrowLeft.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
